<div>
    <div>
        <sidebar-menu>
            <div class="sidebar-title">
                <hr />
                <div>Locations</div>
            </div>

            <hr class="sidebar-hr" />

            <div class="sidebar-body">
                <!-- Stores MenuLevel1 -->
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenuLevel1Item === menuLevel1Enum.Stores}"
                       (click)="onMenuLevel1Click(menuLevel1Enum.Stores)">Stores</a>
                </div>
                <!-- Stores MenuLevel2 -->
                <div *ngIf="selectedStoreId" class="pmlr-menu-level2-wrap">
                    <!-- Stores Title -->
                    <div class="flex-row pmlr-menu-level2-wrap-title">
                        <div class="pmlr-menu-level2-title-point"></div>
                        <div class="pmlr-menu-level2-title">&nbsp;-&nbsp;{{selectedStoreId}}</div>
                    </div>
                    <!-- Stores MenuLevel2 items -->
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showStoreDetails}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.StoreDetails)">Store Details</a>
                    </div>
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showInventory}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.Inventory)">Inventory</a>
                    </div>
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showEmployee}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.Employee)">Employee</a>
                    </div>
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showStoreHours}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.StoreHours)">Store Hours</a>
                    </div>
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showHandoff}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.Handoff)">Handoff</a>
                    </div>
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': activeMenuLevel2Item === menuLevel2Enum.LegalDocuments}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.LegalDocuments)">Legal Documents</a>
                    </div>
                    <!-- Legal Documents MenuLevel3 items -->
                    <div class="pmlr-menu-level3-wrap" *ngIf="activeMenuLevel2Item === menuLevel2Enum.LegalDocuments">
                        <div class="sidebar-block-link-level2">
                            <a [ngClass]="{'active': activeMenuLevel3Item === menuLevel3Enum.BusinessPermit}"
                               (click)="onMenuLevel3Click(menuLevel3Enum.BusinessPermit)">Business Permit</a>
                        </div>
                        <div class="sidebar-block-link-level2">
                            <a [ngClass]="{'active': activeMenuLevel3Item === menuLevel3Enum.BIR2303}"
                               (click)="onMenuLevel3Click(menuLevel3Enum.BIR2303)">BIR 2303</a>
                        </div>
                    </div>

                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showActiveServices}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.ActiveServices)">Active Services</a>
                    </div>
                </div>

                <!-- Groups MenuLevel1 -->
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenuLevel1Item === menuLevel1Enum.Groups}"
                       (click)="onMenuLevel1Click(menuLevel1Enum.Groups)">Groups</a>
                </div>
                <!-- Groups MenuLevel2 -->
                <div *ngIf="selectedGroup.Id" class="pmlr-menu-level2-wrap">
                    <!-- Groups Title -->
                    <div class="flex-row pmlr-menu-level2-wrap-title">
                        <div class="pmlr-menu-level2-title-point"></div>
                        <div class="pmlr-menu-level2-title">&nbsp;-&nbsp;{{selectedGroup.Id}}</div>
                    </div>
                    <!-- Groups MenuLevel2 items -->
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showGroupDetails}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.GroupDetails)">Group Details</a>
                    </div>
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showGroupStores}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.GroupStores)">Stores</a>
                    </div>
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showGroupInventory}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.GroupInventory)">Inventory</a>
                    </div>
                    <div class="sidebar-block-link-level2">
                        <a [ngClass]="{'active': showGroupStoreHours}"
                           (click)="onMenuLevel2Click(menuLevel2Enum.GroupStoreHours)">Store Hours</a>
                    </div>
                </div>
            </div>
        </sidebar-menu>
    </div>
<!-- 
    <div class="sidebar-next-right-block main-merchant layout-location" [ngClass]="{
'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
'root-body-horizontal': configService.config.menuMode === 'horizontal'}"> -->
<div class="sidebar-next-right-block main-merchant layout-location root-body-sidebar-slim custom-w">
        <!-- Stores MenuLevel1 -->
        <partner-mart-locations *ngIf="activeMenuLevel1Item === menuLevel1Enum.Stores && !selectedStoreId" [store]="selectedStore" [storeId]="selectedStoreId" [merchantId]="merchantId"
                                ></partner-mart-locations>
        <!-- Stores MenuLevel2 -->
        <partner-mart-locations-store-details *ngIf="showStoreDetails"
                                              [storeId]="selectedStoreId" [store]="selectedStore"></partner-mart-locations-store-details>
        <partner-mart-locations-inventory *ngIf="showInventory"
                                          [storeId]="selectedStoreId" [merchantId]="merchantId" [store]="selectedStore"></partner-mart-locations-inventory>
        <partner-mart-locations-employee *ngIf="showEmployee"
                                         [storeId]="selectedStoreId" [store]="selectedStore"></partner-mart-locations-employee>
        <partner-mart-locations-store-hours *ngIf="showStoreHours"
                                            [storeId]="selectedStoreId" [store]="selectedStore"></partner-mart-locations-store-hours>
        <partner-mart-locations-handoff *ngIf="showHandoff"
                                        [storeId]="selectedStoreId" [store]="selectedStore"></partner-mart-locations-handoff>
        <partner-mart-locations-legal-documents *ngIf="activeMenuLevel2Item === menuLevel2Enum.LegalDocuments"
                                                [storeId]="selectedStoreId" [store]="selectedStore" [activeDocumentMenuItem]="activeMenuLevel3Item"></partner-mart-locations-legal-documents>
        <partner-mart-locations-active-services *ngIf="showActiveServices"
                                                [storeId]="selectedStoreId"></partner-mart-locations-active-services>

        <!-- Groups MenuLevel1 -->
        <partner-mart-locations-groups *ngIf="activeMenuLevel1Item === menuLevel1Enum.Groups && !selectedGroup.Id"
                                       [merchantId]="merchantId"
                                       [onSelectGroup]="onSelectGroup"></partner-mart-locations-groups>
        <!-- Groups MenuLevel2 -->
        <partner-mart-locations-group-details *ngIf="showGroupDetails"
                                              [groupId]="selectedGroup.Id"></partner-mart-locations-group-details>
        <partner-mart-locations-group-stores *ngIf="showGroupStores"
                                             [groupId]="selectedGroup.Id"
                                             [groupName]="selectedGroup.Name"></partner-mart-locations-group-stores>
        <partner-mart-locations-group-inventory *ngIf="showGroupInventory"
                                                [groupId]="selectedGroup.Id"
                                                [groupName]="selectedGroup.Name"></partner-mart-locations-group-inventory>
        <partner-mart-locations-group-hours *ngIf="showGroupStoreHours"
                                            [groupId]="selectedGroup.Id"
                                            [groupName]="selectedGroup.Name"></partner-mart-locations-group-hours>
    </div>
</div>
